(function() {
  var AngularService,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AngularService = App.loadClass('core::Angular/Service');

  exports.OnFarmStorageService = (function(superClass) {
    extend(OnFarmStorageService, superClass);

    function OnFarmStorageService(http, $resource, $state) {
      var app;
      this.http = http;
      app = $state.current.name.split('.')[0];
      this.StorageLocation = $resource("backend/" + app + "/storage-locations/:id", {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      this.StorageFan = $resource("backend/" + app + "/storage-locations/:binId/fans/:id", {
        binId: '@storage_locations_id',
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      this.BinInspection = $resource("backend/" + app + "/storage-locations/:binId/inspections/:id", {
        binId: '@storage_locations_id',
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
      this.Measurement = $resource('backend/portal/storage-measurements/:id', {
        id: '@id'
      }, {
        update: {
          method: 'PUT'
        }
      });
    }

    OnFarmStorageService.prototype.getYears = function() {
      return this.http.get('backend/portal/on-farm-storage/contract-years').then(function(response) {
        return response.data;
      });
    };

    OnFarmStorageService.prototype.getUsers = function(year) {
      return this.http.get('backend/portal/on-farm-storage/users-by-year', {
        params: {
          year: year
        }
      }).then(function(response) {
        return response.data;
      });
    };

    OnFarmStorageService.prototype.getContracts = function(year, user) {
      return this.http.get('backend/portal/on-farm-storage/contracts-by-year', {
        params: {
          year: year,
          userId: user.id
        }
      }).then(function(response) {
        return response.data;
      });
    };

    OnFarmStorageService.prototype.getBins = function(user) {
      return this.StorageLocation.query({
        userId: user.id
      }).$promise.then(function(bins) {
        return bins.filter(function(bin) {
          return bin.type === 'Bin' || bin.type === 'Silo';
        });
      });
    };

    OnFarmStorageService.prototype.getBinId = function(year, binId) {
      return this.http.get('backend/portal/on-farm-storage/bin-id', {
        params: {
          year: year,
          binId: binId
        }
      }).then(function(response) {
        return response.data;
      });
    };

    OnFarmStorageService.prototype.saveBinId = function(year, bin) {
      return this.http.post('backend/portal/on-farm-storage/save-bin-id', {
        year: year,
        id: bin.id,
        binId: bin.bin_id
      });
    };

    OnFarmStorageService.prototype.getMeasurementId = function(contract, bin) {
      return this.http.get('backend/portal/on-farm-storage/measurement-id', {
        params: {
          contractId: contract.id,
          binId: bin.id
        }
      }).then(function(response) {
        return response.data;
      });
    };

    return OnFarmStorageService;

  })(AngularService);

}).call(this);
